<template>
  <div style="padding-top: 80px">
    <div
      style="
        position: fixed;
        top: 0;
        z-index: 99;
        left: 0;
        right: 0;
        background-color: #fff;
      "
    >
      <div class="header">
        <img :src="logo" class="logo" />
        <div class="header-title">
          <div
            v-for="(item, index) in menuList"
            :key="item.title"
            :class="index === currIndex ? 'cover' : ''"
            @click="jump(item, index)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="tel">
          <img :src="tel" />
          <a
            href="tel:010-63269626"
            style="font-size: 16px; color: rgba(0, 0, 0, 0.85); font-family: PingFang SC"
            >010-63269626</a
          >
        </div>
      </div>
    </div>
    <a name="sy" style="line-height: 0; display: block"></a>
    <!-- 轮播图 -->
    <div class="swiper">
      <!-- <el-carousel :height="height">
        <el-carousel-item v-for="item in 1" :key="item"> -->
      <div class="swiper-item">
        <img src="@/assets/images/lb1.png" />
        <div>
          <div class="swiper-item-title">学术采编系统</div>
          <div class="swiper-item-tips">
            为学术出版提供全流程智能化解决方案，打造高效、专业的数字化<br />出版平台
          </div>
          <div class="swiper-item-btn">开始体验</div>
        </div>
      </div>
      <!-- </el-carousel-item>
      </el-carousel> -->
    </div>

    <!--  -->
    <div class="introduction">
      <div>
        <div class="introduction-title">
          <span> 20 </span>
          年
        </div>
        <div class="introduction-content">
          20年开发与积累提供
          <br />专业化的期刊数字出版平台服务
        </div>
      </div>

      <div>
        <div class="introduction-title">
          <span> 1000 </span>
          种
        </div>
        <div class="introduction-content">
          超过1000种国内一流期刊

          <br />使用公司产品或服务
        </div>
      </div>

      <div>
        <div class="introduction-title">
          <span> 10 </span>
          万
        </div>
        <div class="introduction-content">
          每年有超过10万篇文章

          <br />进行在线发布
        </div>
      </div>

      <div>
        <div class="introduction-title">
          <span> 50 </span>
          万
        </div>
        <div class="introduction-content">
          每年有超过50万人次

          <br />审稿人在线完成审稿
        </div>
      </div>

      <div style="margin-right: 0">
        <div class="introduction-title">
          <span> 1000 </span>
          万
        </div>
        <div class="introduction-content">
          每年有超过1000万人次读者

          <br />通过系统获取最新学术文献
        </div>
      </div>
    </div>

    <!-- 最新媒体 -->
    <a name="xmt" style="line-height: 0; display: block"></a>
    <div class="media">
      <div class="media-title">期刊新媒体</div>
      <div class="media-content">
        <div class="media-content-item">
          <img src="@/assets/images/m1.png" />
          <div>学术人生</div>
          <p>
            学术期刊编委审稿专家学术成就：视频，课件，著作，直播，文献个性定制电子文集。官网，微信，app一库三网一键发布。
          </p>
        </div>

        <div class="media-content-item">
          <img src="@/assets/images/m2.png" />
          <div>知识分享</div>
          <p>专业学科学术期刊权威学术资源激活，实现知识付费有偿服务。</p>
        </div>

        <div class="media-content-item">
          <img src="@/assets/images/m3.png" />
          <div>学术会议</div>
          <p>专业学科领域学术会议一库三网管理系统，会议全程智能管理，移动办公。</p>
        </div>

        <div class="media-content-item" style="margin: 0">
          <img src="@/assets/images/m4.png" />
          <div>视频直播</div>
          <p>专业学术课件视频，直播，流量递增，提升学术期刊业界影响力。</p>
        </div>
      </div>
    </div>

    <!-- 功能 -->
    <a name="zncb" style="line-height: 0; display: block"></a>
    <div class="feature">
      <div class="feature-title">智能采编功能</div>
      <div class="feature-content">
        <div>
          <img src="@/assets/images/g1.png" />
          <p>作者投稿系统</p>
        </div>
        <div>
          <img src="@/assets/images/g2.png" />
          <p>专家审稿系统</p>
        </div>
        <div>
          <img src="@/assets/images/g3.png" />
          <p>编辑流程自定义</p>
        </div>
        <div>
          <img src="@/assets/images/g4.png" />
          <p>学术不端查询</p>
        </div>
        <div>
          <img src="@/assets/images/g5.png" />
          <p>参考文献校对</p>
        </div>
        <div>
          <img src="@/assets/images/g6.png" />
          <p>过刊三网发布系统</p>
        </div>
        <div>
          <img src="@/assets/images/g7.png" />
          <p>APP 移动采编系统</p>
        </div>
        <div>
          <img src="@/assets/images/g8.png" />
          <p>期刊集群文库</p>
        </div>
      </div>
    </div>

    <!-- 贡献 -->
    <a name="jzgx" style="line-height: 0; display: block"></a>
    <div class="contribution">
      <div class="contribution-title">价值贡献</div>
      <div class="contribution-nav">
        <div
          :class="index === contributionCurrIndex ? 'cover' : ''"
          v-for="(item, index) in contributionList"
          @click="contributionCurrIndex = index"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="contribution-content">
        <div class="contribution-content-left">
          <p>{{ contributionList[contributionCurrIndex].title }}</p>
          <div v-for="item in contributionList[contributionCurrIndex].list">
            <img :src="dg" />
            {{ item }}
          </div>
        </div>
        <div
          class="contribution-content-right"
          :style="`background-image: url(${contributionList[contributionCurrIndex].url})`"
        ></div>
      </div>
    </div>

    <!-- 解决方案 -->
    <a name="jjfa" style="line-height: 0; display: block"></a>
    <div class="scheme">
      <div class="scheme-title">解决方案</div>
      <div class="scheme-content">
        <div class="scheme-content-left">
          <div>全流程智能化解决方案</div>
          <p style="text-indent: 2em">
            北京博渊星辰网络科技有限公司是从事学术期刊信息化研发、推广建设及整体解决方案的专业公司。公司根据中国学术期刊的现状，开发了整套新媒体服务智能采编系统和各种新媒体内容的应用场景，让学术期刊可以充分利用期刊自身资源为社会和受众提供各项服务，使学术期刊的行业影响力得到快速提升。还通过为国内不同行业或机构的期刊集群搭建文库，打通不同专业和地域的限制，方便相关专业的作者、编辑人员及科研工作者使用，促进了互联网时代信息技术的发展。
          </p>
          <span> 了解更多 </span>
        </div>
        <div class="scheme-content-right"></div>
      </div>
    </div>

    <!-- 合作 -->
    <a name="hzhb" style="line-height: 0; display: block"></a>
    <div class="cooperation">
      <div class="cooperation-title">合作伙伴</div>
      <div class="cooperation-content">
        <div v-for="item in linkList" @click="open(item.path)">
          <img style="cursor: pointer" :src="item.url" />
        </div>
      </div>
    </div>

    <!-- 关于我们 -->
    <a name="gywm" style="line-height: 0; display: block"></a>
    <div class="about">
      <div class="about-title">关于我们</div>
      <div class="about-content">
        <div style="text-indent: 2em">
          北京博渊星辰网络科技有限公司是从事学术期刊信息化研发、推广建设及整体解决方案的专业公司。公司核心团队从事传媒管理研究及学术期刊数字化研发、运维、服务超过二十年。公司根据中国学术期刊的现状，开发了一整套新媒体服务智能采编系统和各种新媒体内容的应用场景，让学术期刊可以充分利用期刊自身资源为社会和受众提供各项服务，使学术期刊的行业影响力得到快速提升。公司业务还包括为国内很多行业或机构的期刊集群搭建文库，打通不同专业和地域的限制，方便相关专业的作者、编辑人员及科研工作者使用。
        </div>
        <div></div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="contact">
      <div class="contact-title">联系我们</div>
      <div class="contact-content">
        <div>
          <img :src="wm1" />
          <p>公司地址</p>
          <div style="width: 193px">北京市海淀区莲花池东路 小马厂6号华天大厦1222室</div>
        </div>

        <div>
          <img :src="wm2" />
          <p>联系电话</p>
          <div>
            咨询热线：
            <a
              href="tel:010-63269626"
              style="
                font-size: 16px;
                color: rgba(0, 0, 0, 0.65);
                font-family: PingFang SC;
              "
              >010-63269626</a
            >
          </div>
        </div>

        <div>
          <img :src="wm3" />
          <p>电子邮箱</p>
          <div>
            商务合作：
            <a
              href="mailto:boyuanxingchen@163.com"
              style="
                font-size: 16px;
                color: rgba(0, 0, 0, 0.65);
                font-family: PingFang SC;
              "
              >boyuanxingchen@163.com</a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="footer">
      <div class="footer-top">
        <div class="footer-top-left">
          <div>
            <img
              style="margin-top: 38px; margin-bottom: 36px; width: 160px; height: 50px"
              :src="logo1"
            />
          </div>
          <div class="footer-title" style="margin-bottom: 16px">
            法律顾问：北京市京师律师事务所 张腾林律师
          </div>
          <div class="footer-title">联系我们</div>
          <div class="contact-msg">
            <p>咨询电话（工作日 9：00-18：00）</p>
            <p>
              <a href="tel:010-63269626" style="color: #9ca3af; font-family: PingFang SC"
                >010-63269626</a
              >
            </p>
            <p>
              <img :src="d1" />
              <a
                href="mailto:boyuanxingchen@163.com"
                style="color: #9ca3af; font-family: PingFang SC"
                >boyuanxingchen@163.com</a
              >
            </p>
            <p><img :src="d2" />北京市海淀区莲花池东路小马厂6号 华天大厦 1222 室</p>
          </div>
        </div>
        <div class="footer-top-right">
          <div>
            <p>新媒体</p>
            <div>学术会议</div>
            <div>视频直播</div>
            <div>学术人生</div>
          </div>
          <div>
            <p>智能采编</p>
            <div>作者投稿系统</div>
            <div>专家审稿系统</div>
            <div>编辑流程自定义</div>
            <div>学术不端查询</div>
            <div>参考文献校对</div>
            <div>过刊三网发布系统</div>
            <div>APP移动采编系统</div>
          </div>
          <div>
            <p>价值贡献</p>
            <div>作者收益</div>
            <div>专家收益</div>
            <div>期刊收益</div>
            <div>行业收益</div>
            <div>社会贡献</div>
          </div>
          <div style="margin: 0">
            <p>合作伙伴</p>
            <div>共建单位</div>
            <div>行业伙伴</div>
            <div>领域专家</div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div>Copyright@{{ year }} 北京博渊星辰网络科技有限公司 All Rights Reserved</div>
        <div>
          <a href="https://beian.miit.gov.cn/"> 京ICP备2024042010号-2 </a>
        </div>
        <div>
          <a
            style="display: flex; align-items: center; justify-content: center"
            href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802046234"
            rel="noreferrer"
            target="_blank"
            ><img src="@/assets/images/ga1.png" style="width: 20px; margin-right: 5px" />
            京公网安备11010802046234号
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      logo: require("@/assets/images/logo4.png"),
      logo1: require("@/assets/images/logo1.svg"),
      tel: require("@/assets/images/dh.svg"),
      dg: require("@/assets/images/dg.svg"),
      wm1: require("@/assets/images/wm1.svg"),
      wm2: require("@/assets/images/wm2.svg"),
      wm3: require("@/assets/images/wm3.svg"),
      d1: require("@/assets/images/d1.svg"),
      d2: require("@/assets/images/d2.svg"),
      linkList: [
        {
          url: require("@/assets/images/yqlj/13.png"),
          path: "http://www.cppagy.com/",
        },
        {
          url: require("@/assets/images/yqlj/1.png"),
          path: "https://www.cnki.net/",
        },
        {
          url: require("@/assets/images/yqlj/2.png"),
          path: "https://med.wanfangdata.com.cn/",
        },
        {
          url: require("@/assets/images/yqlj/3.png"),
          path: "https://www.baidu.com/",
        },
        {
          url: require("@/assets/images/yqlj/4.png"),
          path: "https://www.cmda.net/",
        },
        {
          url: require("@/assets/images/yqlj/5.png"),
          path: "https://www.cha.org.cn/",
        },
        {
          url: require("@/assets/images/yqlj/6.png"),
          path: "http://www.cessp.org.cn/",
        },
        {
          url: require("@/assets/images/yqlj/7.png"),
          path: "https://www.sysu.edu.cn/",
        },
        {
          url: require("@/assets/images/yqlj/8.png"),
          path: "https://www.whu.edu.cn/",
        },
        {
          url: require("@/assets/images/yqlj/9.png"),
          path: "https://www.hust.edu.cn/",
        },
        {
          url: require("@/assets/images/yqlj/10.png"),
          path: "https://www.pku.edu.cn/",
        },
        {
          url: require("@/assets/images/yqlj/11.png"),
          path: "http://www.cass.cn/",
        },
      ],
      currIndex: 0,
      height: "600px",
      menuList: [
        {
          title: "首页",
          name: "sy",
        },
        {
          title: "新媒体",
          name: "xmt",
        },
        {
          title: "智能采编",
          name: "zncb",
        },
        {
          title: "价值贡献",
          name: "jzgx",
        },
        {
          title: "解决方案",
          name: "jjfa",
        },
        {
          title: "合作伙伴",
          name: "hzhb",
        },
        {
          title: "关于我们",
          name: "gywm",
        },
      ],
      contributionList: [
        {
          title: "作者收益",
          url: require("@/assets/images/j1.png"),
          list: [
            "便捷的在线投稿流程，节省投稿时间",
            "实时跟踪稿件进度，及时获取审稿意见",
            "智能格式检查，提高稿件质量",
            "在线支付版面费，操作更便捷",
          ],
        },
        {
          title: "专家收益",
          url: require("@/assets/images/j2.png"),
          list: [
            "线上审稿，流程精简，节省时间",
            "提升学术声誉，拓展行业影响力",
            "优质资源对接，开拓多元收益",
            "专属职业发展助力，增值未来收益",
          ],
        },
        {
          title: "期刊收益",
          url: require("@/assets/images/j3.png"),
          list: [
            "拓宽传播边界，引爆影响力",
            "汇聚优质资源，提升知名度",
            "多元盈利模式，实现收益增长",
            "树立行业权威，引领发展潮流",
          ],
        },
        {
          title: "行业收益",
          url: require("@/assets/images/j4.png"),
          list: [
            "多平台助力，便捷获取科技创新知识，把握行业先机",
            "知识高效传播，促业界思维碰撞、技术革新，增进行业效益",
            "平台构建知识通道，提升创新效率，加速成果转化与收益提升",
            "知识无界传播，推动产业升级，增强行业竞争力，收获丰厚收益",
          ],
        },
        {
          title: "社会贡献",
          url: require("@/assets/images/j5.png"),
          list: ["维护学术生态", "保障科研价值", "保护作者权益", "引领学术风尚"],
        },
      ],
      contributionCurrIndex: 0,
    };
  },
  methods: {
    open(path) {
      window.open(path, "_blank");
    },
    jump({ name }, index) {
      this.currIndex = index;
      window.location.hash = "#" + name;
    },
  },
  mounted() {
    this.$nextTick((_) => {
      // this.height = this.$refs.bgImg[0].offsetHeight + "px";
      // console.log(this.height, "酷酷酷");
    });
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.header {
  margin: 0 auto;
  width: 1400px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  .logo {
    // margin-right: 138px;
    // width: 160px;
    height: 50px;
  }
  .header-title {
    // margin-right: 200px;
    display: flex;
    align-items: center;

    > div {
      margin-right: 32px;
      position: relative;
      height: 24px;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 600;
      line-height: 28px;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.85);
      cursor: pointer;
    }
    > div:hover {
      color: #1a4da0;
    }
    .cover {
      color: #1a4da0;
    }
    .cover::after {
      content: "";
      width: 100%;
      position: absolute;
      left: 0;
      bottom: -2px;
      height: 2px;
      background-color: #1a4da0;
    }
  }
  .tel {
    display: flex;
    align-items: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0px;
    color: rgba(0, 0, 0, 0.85);
    img {
      margin-right: 12px;
    }
  }
}
.swiper {
  min-width: 1300px;
  img {
    width: 100%;
  }
  &-item {
    position: relative;
    > div {
      position: absolute;
      width: 1300px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .swiper-item-title {
        font-family: PingFang SC;
        font-size: 48px;
        font-weight: 600;
        line-height: 48px;
        letter-spacing: 0px;
        color: rgba(0, 0, 0, 0.85);
      }
      .swiper-item-tips {
        margin: 24px 0 32px;
        font-family: PingFang SC;
        font-size: 18px;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: 0px;
        color: rgba(0, 0, 0, 0.65);
      }
      .swiper-item-btn {
        width: 136px;
        height: 52px;
        border-radius: 8px;
        opacity: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 32px;
        background: #1a4da0;
        font-family: PingFang SC;
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;
        text-align: center;
        letter-spacing: 0px;
        color: #ffffff;
        cursor: pointer;
      }
      .swiper-item-btn:hover {
        background-color: #00368f;
      }
    }
  }
}

.introduction {
  width: 1300px;
  margin: 80px auto;
  display: flex;
  align-items: center;
  > div {
    margin-right: 90px;
    .introduction-title {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 600;
      line-height: 30px;
      color: #1a4da0;
      text-align: center;
      span {
        margin-right: 4px;
        font-family: PingFang SC;
        font-size: 36px;
        font-weight: 600;
        line-height: 40px;
        letter-spacing: 0px;
        color: #1a4da0;
      }
    }
    .introduction-content {
      margin-top: 16px;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 28px;
      text-align: center;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.65);
    }
  }
}

.media {
  min-width: 1300px;
  height: 640px;
  opacity: 1;
  padding: 64px 0px;
  background: #eef4ff;
  &-title {
    margin-bottom: 80px;
    height: 36px;
    font-family: PingFang SC;
    font-size: 30px;
    font-weight: 600;
    line-height: 36px;
    text-align: center;
    color: #000000;
  }
  &-content {
    display: flex;
    justify-content: center;
    &-item {
      padding: 12px;
      margin-right: 32px;
      width: 284px;
      height: 380px;
      border-radius: 16px;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)),
        #ffffff;
      box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.05);
      img {
        width: 100%;
      }
      > div {
        margin-top: 24px;
        margin-bottom: 16px;
        font-family: PingFang SC;
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        text-align: center;
        letter-spacing: 0px;
        color: rgba(0, 0, 0, 0.85);
      }
      p {
        margin: 0 9px;
        width: 243px;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: 0px;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}

.feature {
  margin-top: 80px;
  &-title {
    margin-bottom: 80px;
    height: 36px;
    font-family: PingFang SC;
    font-size: 30px;
    font-weight: 600;
    line-height: 36px;
    text-align: center;
    color: #000000;
  }
  &-content {
    margin: 0 auto;
    width: 1300px;
    display: flex;
    flex-wrap: wrap;
    > div {
      margin-bottom: 24px;
      margin-right: 30px;
      text-align: center;
      padding: 44px;
      width: 297px;
      height: 200px;
      border-radius: 4px;
      background: #f4f8ff;
      cursor: pointer;

      p {
        margin-top: 20px;
        font-family: PingFang SC;
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        color: #000000;
      }
    }
    > div:hover {
      box-shadow: 2px 2px 8px 0px rgba(66, 103, 158, 0.15);
    }
    > div:nth-of-type(4n) {
      margin-right: 0;
    }
  }
}

.contribution {
  width: 1300px;
  margin: 109px auto 64px;
  padding-bottom: 50px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #ffffff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  &-title {
    font-family: PingFang SC;
    font-size: 30px;
    font-weight: 600;
    line-height: 36px;
    text-align: center;
    letter-spacing: 0px;
    color: #000000;
  }
  &-nav {
    display: flex;
    margin-top: 48px;
    > div {
      margin-right: 16px;
      width: 120px;
      height: 52px;
      border-radius: 8px;
      /* 自动布局 */
      display: flex;
      padding: 12px 24px;
      background: #ffffff;
      font-family: PingFang SC;
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
      text-align: center;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.65);
      cursor: pointer;
    }
    .cover {
      background-color: #1a4da0;
      color: #ffffff;
    }
  }
  &-content {
    margin-top: 92px;
    display: flex;
    &-left {
      margin-right: 52px;
      width: 568px;
      height: 200px;
      padding: 70px 48px 0px 0px;
      background: rgba(0, 0, 0, 0);
      p {
        margin-bottom: 24px;
        font-family: Roboto;
        font-size: 24px;
        font-weight: bold;
        line-height: 32px;
        letter-spacing: 0px;
        color: #000000;
      }
      div {
        display: flex;
        align-items: center;
        margin-left: 16px;
        margin-bottom: 16px;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: 0px;
        color: #000000;
        img {
          margin-right: 16px;
        }
      }
    }
    &-right {
      width: 612px;
      height: 343px;
      border-radius: 16px;
      z-index: 1;
      overflow: hidden;
      background-position: 50% 66%;
    }
  }
}

.scheme {
  min-width: 1300px;
  height: 584px;
  padding: 64px 0px;
  background: #f8f9fa;
  &-title {
    font-family: PingFang SC;
    font-size: 30px;
    font-weight: 600;
    line-height: 36px;
    text-align: center;
    letter-spacing: 0px;
    color: #000000;
  }
  &-content {
    margin: 48px auto 0;
    width: 1300px;
    display: flex;
    &-left {
      padding-top: 60px;
      div {
        width: 240px;
        height: 32px;
        font-family: Roboto;
        font-size: 24px;
        font-weight: bold;
        line-height: 32px;
        letter-spacing: 0px;
        color: #000000;
      }
      p {
        margin: 24px 0 32px;
        width: 578px;
        font-family: Roboto;
        font-size: 16px;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: 0px;
        color: #4b5563;
      }
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 136px;
        height: 52px;
        border-radius: 8px;
        padding: 12px 32px;
        background: #1a4da0;
        font-family: Roboto;
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;
        text-align: center;
        letter-spacing: 0px;
        color: #ffffff;
        cursor: pointer;
      }
    }
    &-right {
      margin-left: 88px;
      width: 616px;
      height: 371.92px;
      border-radius: 16px;
      background: rgba(0, 0, 0, 0);
      background-image: url("@/assets/images/jj.png");
      background-position: 0 -20px;
    }
  }
}

.cooperation {
  margin-top: 64px;
  &-title {
    margin-bottom: 54px;
    font-family: PingFang SC;
    font-size: 30px;
    font-weight: 600;
    line-height: 36px;
    text-align: center;
    letter-spacing: 0px;
    color: #000000;
  }
  &-content {
    margin: 0 auto;
    width: 1300px;
    display: flex;
    flex-wrap: wrap;
    > div {
      margin-bottom: 30px;
      margin-right: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 193px;
      height: 82px;
      border-radius: 14px;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)),
        #ffffff;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
      img {
        width: 167px;
        height: 64px;
      }
    }
    > div:nth-of-type(6n) {
      margin-right: 0;
    }
  }
}

.about {
  margin-top: 120px;
  &-title {
    font-family: PingFang SC;
    font-size: 30px;
    font-weight: 600;
    line-height: 36px;
    text-align: center;
    letter-spacing: 0px;
    color: #000000;
  }
  &-content {
    width: 1300px;
    margin: 48px auto 65px;
    display: flex;
    align-items: center;
    > div:first-of-type {
      margin-right: 84px;
      width: 580px;
      font-family: Roboto;
      font-size: 16px;
      font-weight: normal;
      line-height: 28px;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.85);
    }
    > div:last-of-type {
      /* 自动布局子元素 */
      width: 616px;
      height: 492.8px;
      border-radius: 16px;
      background: url("@/assets/images/gywm.png");
      overflow: hidden;
    }
  }
}

.contact {
  min-width: 1300px;
  padding-top: 64px;
  padding-bottom: 64px;
  background-color: #f9fafb;
  &-title {
    margin-bottom: 48px;
    font-family: PingFang SC;
    font-size: 30px;
    font-weight: 600;
    line-height: 36px;
    text-align: center;
    letter-spacing: 0px;
    color: #000000;
  }
  &-content {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    > div {
      margin-right: 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 406px;
      height: 208px;
      border-radius: 16px;
      padding: 32px;
      background: #ffffff;
      text-align: center;
      div {
        height: 48px;
        font-family: Roboto;
        font-size: 16px;
        font-weight: normal;
        line-height: 28px;
        text-align: center;
        letter-spacing: 0px;
        color: rgba(0, 0, 0, 0.65);
      }
      p {
        margin: 16px 0;
        font-family: PingFang SC;
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        text-align: center;
        letter-spacing: 0px;
        color: #000000;
      }
    }
  }
}

.footer {
  min-width: 1300px;
  background: #111827;
  &-top {
    display: flex;
    justify-content: space-between;
    width: 1300px;
    margin: 0 auto;
    &-right {
      display: flex;
      padding-top: 40px;
      p {
        margin-bottom: 16px;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 0px;
        color: #ffffff;
      }
      > div {
        width: 112px;
        margin-right: 50px;
        > div {
          margin-bottom: 12px;
          height: 24px;
          opacity: 1;
          background: rgba(0, 0, 0, 0);
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: normal;
          line-height: 28px;
          letter-spacing: 0px;
          color: #9ca3af;
        }
      }
    }
  }
  &-title {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0px;
    color: #ffffff;
  }
  .contact-msg {
    margin-top: 20px;
    p {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 28px;
      letter-spacing: 0px;
      color: #9ca3af;
      img {
        margin-right: 8px;
      }
    }
  }

  &-bottom {
    padding-bottom: 20px;
    padding-top: 24px;
    border-top: 1px solid #1f2937;
    width: 1300px;
    margin: 30px auto;
    text-align: center;
    div {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 28px;
      text-align: center;
      letter-spacing: 0px;
      color: #9ca3af;
    }
    a {
      margin-top: 8px;
      color: #9ca3af;
    }
  }
}
</style>
